import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { GeneralResponse } from 'src/app/core/models/general-response/general-response';
import { environment } from 'src/environments/environment';
import { HttpHeadersPortal, HttpService } from '../../http/http.service';
import { HandleErrorHttpService } from '../handlers/handleErrorHttp.service';
import { SolicitudValida } from '../../models/request/solicitud-valida';

@Injectable({
  providedIn: 'root'
})
export class RequestService {

  urlBlob = environment.BLOB_STORAGE_URL;
  url2 = environment.GESTOR_SOLICITUDES.API_CLIENTE.PREFIJO_URL;
  urlcm = environment.GESTOR_DE_CONTENIDO_URL;
  private headers: HttpHeadersPortal;

  public devolucionesIds = new BehaviorSubject<any[]>([])
  public devolucionesIds$ = this.devolucionesIds.asObservable();

  constructor(
    private httpService: HttpService,
    private handleErrorHttpService: HandleErrorHttpService
  ) { }

  async getReasons(idRequestType) {
    let response = await fetch(this.urlBlob + idRequestType + ".jsonc");
    if (response.ok) {
      let data = await response.json();
      return data;
    } else {
      return "Error - " + response.status;
    }
  }

  public getProcesActive(numberDocument, typeDocument, params): Observable<any> {
    return this.httpService.get(
      this.url2,
      `/request/valid/${typeDocument}/${numberDocument}`,
      {},
      params
    );
  }

  public sendUpdate(formData: FormData): Observable<GeneralResponse<any>> {
    const options = {
      reportProgress: true
    };

    return this.httpService.put(
      this.url2,
      '/archivo/cargar',
      formData,
      {},
      {},
      options
    )
      .pipe(
        map((res: any) => res),
        catchError(this.handleErrorHttpService.errorHandle)
      );
  }

  public getReasonForId(idRequestType, idReason): Observable<any> {
    return this.httpService.get(
      "assets",
      `/mockups/${idRequestType}.jsonc`
    ).pipe(
      map((data: any) => {
        return data.reason.find(reason => reason.id === idReason)
      })
    );
  }

  async getReasonForIdAsync(idRequestType, idReason) {
    let response = await fetch(this.urlBlob + idRequestType + ".jsonc");
    if (response.ok) {
      let data = await response.json();
      if (data.reason) {
        const found = data.reason.find(element => element.id === idReason);
        return found;
      } else {
        return "Error - " + response.status;
      }
      // data.id === idRequestType ? //console.log(data.id)://console.log(null)
    } else {
      return "Error - " + response.status;
    }
  }

  public sendRequest(formData: FormData): Observable<GeneralResponse<any>> {
    return this.httpService.post(
      this.url2,
      '/request/create',
      formData
    ).pipe(
      map((res: any) => res),
      catchError(this.handleErrorHttpService.errorHandle));
  }

  public sendRequestNew(formData: FormData): Observable<GeneralResponse<any>> {
    return this.httpService.post(
      this.url2,
      '/request/createRequest',
      formData
    ).pipe(
      map((res: any) => res),
      catchError(this.handleErrorHttpService.errorHandle));
  }

  public sendRequestFile(formData: FormData): Observable<GeneralResponse<any>> {
    return this.httpService.post(
      this.url2,
      '/request/upload-file',
      formData
    ).pipe(
      map((res: any) => res),
      catchError(this.handleErrorHttpService.errorHandle));
  }

  public sendUpdateRequest(radicado: string, estado: any): Observable<GeneralResponse<any>> {
    const params = {
      radicado,
      estado: estado.toString(),
      portal: '2'
    };

    return this.httpService.put(
      this.url2,
      '/request/updatestate',
      params
    );
  }

  public sendUpdateRequestBloqueoSap(radicado: string, estado: any, observation: string): Observable<GeneralResponse<any>> {
    const solicitud = {
      'radicado': radicado,
      'estado': estado.toString(),
      'portal': "2",
      'observation': observation
    }

    return this.httpService.put(
      this.url2,
      '/request/bloqueosap',
      solicitud
    );
  }

  public getRequestId(idRequest): Observable<any> {
    let params = {
      code: idRequest,
      portal: '2'
    };

    return this.httpService.get(
      this.url2,
      '/request',
      params
    );
  }

  public getActiveBeneficiaryRemoval(): Observable<any> {
    return this.httpService.get(
      this.urlcm,
      '/ocultar/funcionalidad'
    );
  }

  public actualizarDocumento(documentoId: number, url: string, archivo: File): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('documentoId', documentoId.toString());
    formData.append('url', url);
    formData.append('archivo', archivo);

    return this.httpService.put(
      environment.GESTOR_SOLICITUDES.API_CLIENTE.PREFIJO_URL,
      '/api/documentos/actualizar',
      formData
    );
  }

  public obtenerDocumentosDevueltos(NumeroDocEmpresa: string): Observable<any> {
    const params = {
      NumeroDocEmpresa: NumeroDocEmpresa
    };
    return this.httpService.get<any>(
      environment.GESTOR_SOLICITUDES.API_CONSULTAS.PREFIJO_URL,
      '/api/documentos/devueltos',
      params
    );
  }

  public obtenerDetalleSolicitud(solicitudId: string): Observable<any> {
    return this.httpService.get<any>(
      environment.GESTOR_SOLICITUDES.API_CONSULTAS.PREFIJO_URL,
      `/solicitudes/${solicitudId}`);
  }

  getDataRequestValid(params: any): Observable<SolicitudValida> {
    return this.httpService.get<SolicitudValida>(
      `${environment.GESTOR_SOLICITUDES.API_CONSULTAS.PREFIJO_URL}`,
      '/request/valid',
      params
    );
  }

  public checkDevueltos(NumeroDocEmpresa: string): Observable<any> {
    const params = {
      documento: NumeroDocEmpresa,
      portal: 2
    };
    return this.httpService.get<any>(
      environment.GESTOR_SOLICITUDES.API_CONSULTAS.PREFIJO_URL,
      '/api/documentos/check-devueltos',
      params
    );
  }

  /**
 * setea la variable de los ids de las devoluciones, esta variable es un observable
 * que esta atento a cualquier cambio de eventos
 * @param devolucionesIds array con los ids de las
 */
  public actualizarIdsDevoluciones(devolucionesIds: any[]) {
    this.devolucionesIds.next(devolucionesIds)
  }


}
